var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.show ? _c('li', _vm._g({
    attrs: {
      "role": "presentation"
    }
  }, _vm.$listeners), [_c('button', {
    staticClass: "inline-block outline-none p-4",
    attrs: {
      "id": `${_vm.id}-tab`,
      "aria-controls": _vm.id,
      "aria-selected": _vm.selected,
      "data-tabs-target": `#${_vm.id}`,
      "role": "tab",
      "type": "button"
    }
  }, [_vm._t("default")], 2)]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }